/**
 * 预览：iframe 加载 runtime dev server。
 * 协议：iframe → {type:'h5:ready'}；编辑器 → {type:'h5:doc', doc} / {type:'h5:goto', index}
 */
import { useEffect, useRef, useState } from 'react';
import { Modal, Alert } from 'antd';
import { useEditorStore } from '../store/store';

// 不写死 localhost：手机/其他机器通过局域网 IP 打开编辑器时，预览 iframe 也走同一主机名
const RUNTIME_URL = (import.meta.env.VITE_RUNTIME_URL as string | undefined) ?? `${window.location.protocol}//${window.location.hostname}:5174`;

export function PreviewModal() {
  const open = useEditorStore((s) => s.ui.previewOpen);
  const setPreviewOpen = useEditorStore((s) => s.setPreviewOpen);
  const doc = useEditorStore((s) => s.doc);
  const currentPageId = useEditorStore((s) => s.ui.currentPageId);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [ready, setReady] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  const post = (msg: unknown) => iframeRef.current?.contentWindow?.postMessage(msg, '*');

  useEffect(() => {
    if (!open) { setReady(false); setTimedOut(false); return; }
    const onMsg = (e: MessageEvent) => {
      if (e.data?.type === 'h5:ready') setReady(true);
    };
    window.addEventListener('message', onMsg);
    const t = setTimeout(() => setTimedOut(true), 4000);
    return () => { window.removeEventListener('message', onMsg); clearTimeout(t); };
  }, [open]);

  useEffect(() => {
    if (!open || !ready) return;
    post({ type: 'h5:doc', doc });
    const index = doc.pages.findIndex((p) => p.id === currentPageId);
    if (index >= 0) post({ type: 'h5:goto', index });
  }, [open, ready, doc, currentPageId]);

  return (
    <Modal open={open} onCancel={() => setPreviewOpen(false)} footer={null} title="预览" width={460} destroyOnClose centered>
      {!ready && timedOut && (
        <Alert type="warning" showIcon style={{ marginBottom: 8 }} message={`运行时未响应，请确认 ${RUNTIME_URL} 已启动（pnpm dev:runtime）`} />
      )}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <iframe
          ref={iframeRef}
          title="预览"
          src={RUNTIME_URL}
          style={{ width: 375, height: 667, border: '8px solid #222', borderRadius: 24, background: '#fff' }}
        />
      </div>
    </Modal>
  );
}
